// extracted by mini-css-extract-plugin
export default {"root":"MultipleModalBlockInfo_root__z8cA-","placeHolderShimmer":"MultipleModalBlockInfo_placeHolderShimmer__4noSi"};